export var DISCOUNT_TYPES;
(function (DISCOUNT_TYPES) {
  DISCOUNT_TYPES["VALUE"] = "VALUE";
  DISCOUNT_TYPES["PERCENT"] = "PERCENT";
})(DISCOUNT_TYPES || (DISCOUNT_TYPES = {}));